import { useCallback, useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { ChatFormValues } from 'features/chat/config/types/ChatForm';
import {
  EditMessageNullable,
  ParentMessageNullable,
} from 'features/chat/config/types/ParentMessage';

export const useChatMessagesActions = () => {
  const [parentMessage, setParentMessage] =
    useState<ParentMessageNullable>(null);

  const [editedMessage, setEditedMessage] = useState<EditMessageNullable>(null);
  const { setValue } = useFormContext<ChatFormValues>();

  useEffect(() => {
    setValue('text', editedMessage?.text ?? '');
  }, [setValue, editedMessage]);

  const handleParentMessageChange = useCallback(
    (parentMessage: ParentMessageNullable | null) => {
      setEditedMessage(null);
      setParentMessage(parentMessage);
    },
    [setEditedMessage]
  );

  const handleEditedMessageChange = useCallback(
    (editedMessage: EditMessageNullable | null) => {
      setParentMessage(null);
      setEditedMessage(editedMessage);
    },
    [setParentMessage]
  );

  return {
    parentMessage,
    setParentMessage: handleParentMessageChange,
    editedMessage,
    setEditedMessage: handleEditedMessageChange,
  };
};
